import { render, staticRenderFns } from "./distributionGoods.vue?vue&type=template&id=f2195744&"
import script from "./distributionGoods.vue?vue&type=script&lang=js&"
export * from "./distributionGoods.vue?vue&type=script&lang=js&"
import style0 from "./distributionGoods.vue?vue&type=style&index=0&id=f2195744&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports